export default __webpack_public_path__ + "c211129067a8932c6703f01123d2775a.png";